module.exports = __webpack_public_path__ + "static/img/Gold Nova II.41d560d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/csgo/ranks/Gold Nova II.png
// module id = riaf
// module chunks = 35